// extracted by mini-css-extract-plugin
export var active = "_hg-7";
export var blink = "_hg-8";
export var dropDownSelector = "_hg-4";
export var dropDownWrapper = "_hg-3";
export var fakeCursor = "_hg-6";
export var fontSizeButton = "_hg-9";
export var formQuillEditor = "_hg-0";
export var pressed = "_hg-a";
export var qlBlank = "_hg-1";
export var textFormattingToolbar = "_hg-2";
export var textToolbarOption = "_hg-5";